import { matchingMode, matchingModeOrganisationKind } from 'Shared/components/Settings/matchingModeSettings'

matchingMode.description = "Choose how to match users to the members they'll see on the Dashboard"

const settingsConfig = {
  matchingMode,
  matchingModeOrganisationKind,
  closeDate: {
    label: 'Close date',
    kind: 'date',
    required: true,
    description: 'The date this dashboard should be completed and closed by.',
  },
}

export default settingsConfig
